import { render, staticRenderFns } from "./signupProblem.vue?vue&type=template&id=61b0bca6"
import script from "./signupProblem.vue?vue&type=script&lang=js"
export * from "./signupProblem.vue?vue&type=script&lang=js"
import style0 from "./signupProblem.vue?vue&type=style&index=0&id=61b0bca6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports